import { render } from "./TheUserContainer.vue?vue&type=template&id=6faf308c"
import script from "./TheUserContainer.vue?vue&type=script&lang=js"
export * from "./TheUserContainer.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__